import { jsxs as l, jsx as c } from "react/jsx-runtime";
const e = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25",
    ...o,
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#woocommerce-colored_svg__a)", children: [
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#9B5C8F",
            d: "M2.228 5.85h19.534c1.236 0 2.237 1.002 2.237 2.238v7.456c0 1.236-1 2.237-2.237 2.237h-7.005l.961 2.355-4.228-2.355H2.238c-1.236 0-2.237-1-2.237-2.237V8.088A2.227 2.227 0 0 1 2.228 5.85"
          }
        ),
        /* @__PURE__ */ c(
          "path",
          {
            fill: "#fff",
            d: "M1.368 7.89c.136-.186.341-.283.614-.303q.746-.058.849.702c.302 2.04.634 3.766.985 5.18l2.136-4.067q.294-.556.732-.586c.43-.029.693.244.8.82.244 1.297.556 2.4.927 3.336.253-2.478.683-4.263 1.288-5.365.146-.274.36-.41.643-.43.225-.02.43.05.615.195a.76.76 0 0 1 .302.557.85.85 0 0 1-.097.468c-.38.702-.693 1.883-.947 3.521-.243 1.59-.331 2.83-.273 3.717q.03.366-.117.644a.63.63 0 0 1-.517.351c-.253.02-.517-.097-.77-.36-.908-.928-1.63-2.313-2.156-4.156a182 182 0 0 0-1.405 2.809c-.576 1.102-1.063 1.668-1.473 1.697q-.392.03-.683-.673-.746-1.917-1.61-7.404a.83.83 0 0 1 .157-.653M22.33 9.42c-.35-.614-.868-.985-1.56-1.132a2.6 2.6 0 0 0-.527-.058c-.937 0-1.697.488-2.293 1.463a5.17 5.17 0 0 0-.76 2.751q0 1.127.468 1.932c.35.614.868.985 1.56 1.131q.279.06.527.059c.947 0 1.707-.488 2.293-1.463.507-.84.76-1.756.76-2.761.01-.761-.155-1.395-.468-1.922m-1.229 2.702c-.136.644-.38 1.122-.741 1.444q-.424.383-.79.312c-.234-.049-.43-.253-.576-.634a2.5 2.5 0 0 1-.175-.888c0-.243.02-.487.068-.712.088-.4.253-.79.517-1.16.322-.479.663-.674 1.014-.605.235.048.43.253.576.634.117.302.176.604.176.887 0 .254-.02.498-.069.722m-4.877-2.702c-.352-.614-.878-.985-1.561-1.132a2.6 2.6 0 0 0-.527-.058c-.936 0-1.697.488-2.292 1.463a5.17 5.17 0 0 0-.761 2.751q0 1.127.468 1.932c.351.614.868.985 1.56 1.131q.279.06.528.059c.946 0 1.707-.488 2.292-1.463.507-.84.76-1.756.76-2.761 0-.761-.155-1.395-.467-1.922m-1.24 2.702c-.136.644-.38 1.122-.74 1.444q-.426.383-.79.312c-.235-.049-.43-.253-.576-.634a2.5 2.5 0 0 1-.176-.888c0-.243.02-.487.068-.712.088-.4.254-.79.517-1.16.322-.479.664-.674 1.015-.605.234.048.43.253.575.634.118.302.176.604.176.887.01.254-.02.498-.068.722"
          }
        )
      ] }),
      /* @__PURE__ */ c("defs", { children: /* @__PURE__ */ c("clipPath", { id: "woocommerce-colored_svg__a", children: /* @__PURE__ */ c("path", { fill: "#fff", d: "M0 5.85h24v14.343H0z" }) }) })
    ]
  }
);
export {
  e as default
};
